import React from 'react';
import { Route, Switch } from 'react-router-dom';
import HomeApp from './containers/HomeApp';
import ProductionList from '../../containers/ProductionList';
import Contact from './containers/Contact';
import Movie from './containers/Movie';

function normalizeLang(v) {
  const s = (v || '').toLowerCase();
  if (s === 'fi' || s === 'fin' || s === 'finnish') return 'fin';
  if (s === 'en' || s === 'eng' || s === 'english') return 'eng';
  return '';
}

const urlLang = normalizeLang(new URLSearchParams(window.location.search).get('lang'));
const storedLang = normalizeLang(localStorage.getItem('lang'));
const browserLang = ((navigator.language || '').toLowerCase().startsWith('fi') ? 'fin' : 'eng');

const lang = urlLang || storedLang || browserLang;

const Routes = () => (
  <HomeApp>
    <Switch>
      <Route path="/movies/:movieKey" render={(p) => <Movie {...p} lang={lang} />} />
      <Route exact path="/" render={(p) => <ProductionList {...p} lang={lang} />} />
      <Route path="/contact" render={(p) => <Contact {...p} lang={lang} />} />
    </Switch>
  </HomeApp>
);

export default Routes;
